import { render, staticRenderFns } from "./room-stats.vue?vue&type=template&id=33c2e839&scoped=true&"
import script from "./room-stats.vue?vue&type=script&lang=js&"
export * from "./room-stats.vue?vue&type=script&lang=js&"
import style0 from "./room-stats.vue?vue&type=style&index=0&id=33c2e839&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2e839",
  null
  
)

export default component.exports